import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";
import DeleteConfirmationForm from "../../components/forms/DeleteConfirmationForm";
import FilterInput from "../../components/filterDropdown/FilterInput";
import DateRangeFilter from "../../components/filterDropdown/DateRangeFilter";
import { SnackbarData, SnackbarType } from "../../components/Snackbar";
import { generateUniqueNumber } from "../../shared/utility";

export function VisitorsViewModel(logout, addSnackbar) {
  const defaultFilters = {
    startDate: new Date(),
    endDate: new Date(),
  };

  const [filters, setFilters] = useState(defaultFilters);
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [visitors, setVisitors] = useState({ data: [], total: 0 });
  const [showFilters, setShowFilters] = useState(false);

  const showErrorModal = (title, subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title={title}
        />
      ),
      open: true,
    });
  };

  const getVisitors = async function (search, page, filterArg) {
    setLoading(true);
    const payload = {
      page: page,
      filters: { ...filterArg, search: search },
    };

    let callResult = await makePostApiCall(`visitorLogs`, payload);
    setLoading(false);
    if (callResult.success) {
      setVisitors(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      } else {
        showErrorModal("Could not load visitors");
      }
    }
  };

  const resetFilters = () => {
    setFilters(defaultFilters);
    setShowFilters(false);
    getVisitors(null, 1, defaultFilters);
  };

  const deleteVisitor = async function (visitorId) {
    let callResult = await makePostApiCall(
      `visitorLogs/${visitorId}/delete`,
      {},
    );
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getVisitors(null, 1, filters);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message || "Visitor deleted successfully",
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      } else {
        addSnackbar(
          new SnackbarData(
            generateUniqueNumber(),
            callResult.data?.message || "Could not delete visitor",
            SnackbarType.Error,
          ),
        );
      }
    }
  };

  const askDeleteVisitor = function (visitor, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteVisitor(visitor.id)}
          message={`Are you sure you want to delete visitor #${visitor.id}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  const filterComponents = [
    <DateRangeFilter
      key="date"
      onChange={(startDate, endDate) =>
        setFilters({ ...filters, startDate: startDate, endDate: endDate })
      }
      endDate={filters.endDate}
      startDate={filters.startDate}
      setShowDates={() => {}}
      showDates={false}
      applyChanges={() => {}}
      maxDate={new Date()}
      rangeSummary={""}
    />,
    <FilterInput
      key="search"
      header="Search"
      onChange={(value) => setFilters({ ...filters, search: value })}
      resetFilter={() => setFilters({ ...filters, search: null })}
      valueName="search"
      value={filters.search}
    />,
  ];

  return {
    askDeleteVisitor,
    emptyModal,
    loading,
    setEmptyModelOpen,
    filters,
    resetFilters,
    showFilters,
    setShowFilters,
    filterComponents,
    visitors,
    getVisitors,
    setFilters,
  };
}

export default VisitorsViewModel;
